import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { Presence } from 'lib-shared-legacy-types';
import { ReactNode } from 'react';

import { getMetaWorkingMedia, mediaAttributes } from 'utils/channels/media';
import { getMediaFeatureFlagStatus } from 'utils/featureFlagging/channelFeatureFlags';

import styles from './presenceOverlayChannels.module.scss';

type PresenceOverlayChannelsProps = {
  presence: Presence;
};

const PresenceOverlayChannels = ({
  presence,
}: PresenceOverlayChannelsProps): JSX.Element => {
  const mediaFeatureFlagStatus = getMediaFeatureFlagStatus();
  const hasMediaSpeak = mediaFeatureFlagStatus.get('speak');

  const metaMedia = getMetaWorkingMedia(presence.working_channels);
  const { simultaneous_ringing: simRingActive } = presence.presence_status;

  const simultaneousRingChannel: ReactNode = hasMediaSpeak ? (
    <Tooltip
      content={`Simultaneous ring is turned ${simRingActive ? 'on' : 'off'}`}
    >
      <span className={classnames(styles.iconHolder)}>
        <Icon
          name="simultaneous"
          size={20}
          color={simRingActive ? colors.neutral['600'] : colors.neutral['400']}
          className={classnames('simultaneous-bold', { active: simRingActive })}
        />
      </span>
    </Tooltip>
  ) : null;

  return (
    <div className={styles.statusHolder}>
      <div className={styles.icons}>
        <div className={styles.iconsHolder}>
          {metaMedia.map((media) => {
            if (!media.enabled) return null;
            return (
              <Tooltip
                key={media.name}
                content={`${mediaAttributes[media.name].name} is turned ${
                  media.working ? 'on' : 'off'
                }`}
              >
                <span className={classnames(styles.iconHolder)}>
                  <Icon
                    name={mediaAttributes[media.name].icon}
                    size={20}
                    color={
                      media.working
                        ? colors.neutral['600']
                        : colors.neutral['400']
                    }
                    className={classnames(
                      mediaAttributes[media.name].legacyIcon,
                      { [styles.active]: media.working },
                    )}
                  />
                </span>
              </Tooltip>
            );
          })}
          {simultaneousRingChannel}
        </div>
      </div>
    </div>
  );
};

export default PresenceOverlayChannels;
